export default __webpack_public_path__ + "static/media/img-31.66be4a7d.jpg";